import styled from "styled-components";

export const SpinnerContainer = styled.span`
  display: inline-block;
  color: currentColor;
  animation: loader-spin 1s ease infinite;

  @keyframes loader-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
